import React, {useEffect, useState} from 'react';
import {InternalPageRoot, Survey_AddEditQsPage, ThemedButton, ThemedIconButton} from "../../../index";
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullStr,
    getArrLen,
    getCurrUrlParamValue,
    getJsonValue,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    isJsonValueTrue
} from "../../../../common/fusion-ui/utils/ReactUtils";
import {isCurrUserRoleAdmin, printError, printLog, sendRequest} from "../../../utils/AppUtils";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {DefStrNA, IconClass} from 'common/fusion-ui/config/FusionConfig';
import {GenRouteUrls, ModuleFieldsData, Modules, ReqUrls, ShowViewType} from "../../../config/AppConfig";
import {CssVariant, Messages} from '../../../../common/fusion-ui/config/FusionConfig';
import {Flexbox, GridBox, Label, Section} from "../../../../common/fusion-ui";
import useScreenSize from "../../../../common/fusion-ui/hook/useScreenSize";

const Survey_ViewQsPage = React.memo(({
                                          open,
                                          onHide,
                                          recordId,
                                          showAs = ShowViewType.PAGE,
                                      }) => {
    const TAG = "Survey_ViewQsPage";

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isScreenUpSm, isScreenXs, isScreenSm} = useScreenSize();

    const mf = ModuleFieldsData[Modules.Survey_ViewQs];
    const mf_srv = ModuleFieldsData[Modules.Survey];

    const Fields = {
        surveyRecord: 'surveyRecord',
        surveyId: 'surveyId',
        recordList: 'recordList',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFetched: 'isDataFetched',

        currRecordId_delete: 'currRecordId_delete',

        addEditQPage_editModeOn: 'addEditQPage_editModeOn',
        currRecordId_addEditQ: 'currRecordId_addEditQ',
        showAddEditQsPopup: 'showAddEditQsPopup',

        recordDeleteBtn_AsLoading: 'recordDeleteBtn_AsLoading',
        recordDeleteBtn_Disable: 'recordDeleteBtn_Disable',
    };

    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        log('useEffect.showAs:', showAs, 'recordId:', recordId);
        if (showAs == ShowViewType.PAGE) {
            const id = getCurrUrlParamValue('id');
            fetchPageData(id, true);
        } else {
            if (checkNullStr(recordId)) {
                fetchPageData(recordId, false);
            }
        }
    }, [recordId, showAs]);

    return (<>
        <InternalPageRoot
            tag={TAG}
            moduleName={Modules.Survey}
            title={Modules.Survey_ViewQs}
            backToListText={'Back to surveys'}
            isDataFound={getField(Fields.isDataFound)}
            isDataLoading={getField(Fields.isDataLoading)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            internalPageUrl={GenRouteUrls.survey_internalPage}
            showPrev={false}
            showNext={false}
            // prevRecordId={5}
            // nextRecordId={6}
            open={open}
            onHide={onHide}
            showAs={showAs}
            freeComponent={(!isFieldTrue(Fields.isDataLoading) && !isFieldTrue(Fields.isDataFound)) &&
                <div className={'position-absolutex bg-infox'}
                     style={{top: '0rem'}}>
                    {createHeader()}
                </div>}
        >
            <div className={`${(showAs == ShowViewType.DRAWER || showAs == ShowViewType.DIALOG) ? 'mt-1' : ''}`}>
                {createHeader()}
                <div style={{color: theme.text}}>
                    {createQsPanel()}
                </div>
            </div>
        </InternalPageRoot>
        {createCreateQsPopup()}
    </>);

    function createHeader() {
        return <Flexbox className={'mt-n2x'}
                        justifyAt={'between'} alignAt={'center'}
                        justifyAtSm={'start'} alignAtSm={'start'}
                        wrapSm={'sm'} directionSm={'column'}>
            {/*survey-name*/}
            <div className={''}>
                <Label className={`m-0 p-0 text-wrap fw-semi-bold fs-normal`} textAt={'start'} color={theme.text60}>
                    <span className={'text-nowrap'}>Survey Name:</span>
                    <span className={'text-primary ps-1 fw-bold'}>
                            {getJsonValue(getField(Fields.surveyRecord), mf_srv.title.column)}
                        </span>
                </Label>
            </div>

            {/*add-q-btn*/}
            <ThemedButton
                className={'rounded-2 w-auto px-2 py-1 text-nowrap fs-sm'}
                text={'Add new survey question'}
                ml={1}
                variant={theme.primaryBlue}
                hoverBgColor={theme.primaryBlueDark}
                href={`${GenRouteUrls.survey_createQsPage}${getField(Fields.surveyId)}`}
                onClick={(e) => {
                    if (!isScreenUpSm) {
                        e.preventDefault();
                        if (e.ctrlKey) {
                            window.open(`${GenRouteUrls.survey_createQsPage}${getField(Fields.surveyId)}`, '_blank');
                        } else {
                            updateField(Fields.addEditQPage_editModeOn, false);
                            updateField(Fields.currRecordId_addEditQ, -1);
                            updateField(Fields.showAddEditQsPopup, true);
                        }
                    }
                }}
            />
        </Flexbox>
    }

    function createQsPanel() {
        return <Section className={`h-100 p-0 m-0 mt-2`}
                        title={'Your Questions for the survey'}
                        titleAt={'start'}
                        titleClassName={'fw-semi-bold'}
                        borderless={true}
                        titleColor={theme.text80}
                        titleIconStyle={{color: theme.text80}}
                        titleIconClass={''}
                        titleIcon={`${IconClass.edit2} pe-1`}
        >
            <GridBox className={'px-2'} md={getArrLen(getRecordList()) === 1 ? 12 : 6}>
                {checkNullArr(getRecordList()) ?
                    getRecordList().map((item, index) => {
                        return createSingleQuestionBox(item, index)
                    })
                    : <Label className={'m-0 p-1 mt-2 '} textAt={'start'} color={theme.text}>No questions found!</Label>
                }
            </GridBox>
        </Section>

        function createSingleQuestionBox(itemData = {}, index) {
            const qId = getItemField(mf.recordId);
            return <Section
                key={qId + getItemField(mf.question)}
                className={`w-100 m-0 p-2 h-100 app-section hover ${isItemActive() ? `border-primary highlight-primary-light-hover` : `border-danger highlight-danger-light-hover`}`}
                title={<span className={'fw-semi-bold'}>{index + 1}. Question: <span className={'fw-normal'}>{getItemField(mf.question)}</span></span>}
                titleClassName={'px-2 fw-semi-bold text-wrap'}
                titleAt={'start'}
                contentClassName={'px-4 py-0'}
                roundedVariant={4}
                bg={`${isItemActive() ? 't' : 't'}`}
            >
                {/*type*/}
                <p className={`w-100 p-0 m-0`}>
                <span className={'fw-semi-bold pe-1'}>
                    Type:
                </span>
                    {getItemField(mf.answerType, DefStrNA)}
                </p>

                {isCurrUserRoleAdmin() &&
                    <Flexbox className={'mt-1'} justifyAt={'start'} alignAt={'start'}>
                        {/* edit-btn */}
                        <ThemedIconButton
                            wrapperClassName={''}
                            className={`${!isItemActive() ? 'disable-item' : ''}`}
                            tooltip={'Edit'}
                            m={1}
                            mt={''}
                            color={theme.primaryBlue}
                            hoverBgColor={theme.primaryBlue}
                            borderColor={theme.primaryBlue}
                            outlined={true}
                            bgColor={''}
                            icon={'bi bi bi-pencil'}
                            iconSize={'11px'}
                            size={'26px'}
                            disableVariant={''}
                            disabled={!isItemActive()}
                            href={`${GenRouteUrls.survey_editQsPage}${qId}&sid=${getField(Fields.surveyId)}`}
                            onClick={(e) => {
                                if (!isScreenUpSm) {
                                    e.preventDefault();
                                    if (e.ctrlKey) {
                                        window.open(`${GenRouteUrls.survey_editQsPage}${qId}&sid=${getField(Fields.surveyId)}`, '_blank');
                                    } else {
                                        updateField(Fields.currRecordId_addEditQ, qId);
                                        updateField(Fields.showAddEditQsPopup, true);
                                        updateField(Fields.addEditQPage_editModeOn, true);
                                    }
                                }
                            }}
                        />

                        {/* delete-btn */}
                        <ThemedIconButton
                            className={''}
                            tooltip={isItemActive() ? 'Delete' : 'Enable'}
                            m={1}
                            mx={2}
                            variant={isItemActive() ? 'red' : theme.primaryBlue}
                            bgColor={''}
                            hoverBgColor={isItemActive() ? 'red' : theme.primaryBlue}
                            outlined={true}
                            icon={isItemActive() ? 'bi bi bi-trash' : IconClass.checkAll}
                            iconSize={'11px'}
                            size={'26px'}
                            loadingVariant={CssVariant.light}
                            disabled={getField(Fields.currRecordId_delete) === qId && getField(Fields.recordDeleteBtn_Disable)}
                            asLoading={getField(Fields.currRecordId_delete) === qId && getField(Fields.recordDeleteBtn_AsLoading)}
                            onClick={() => {
                                if (isItemActive()) {
                                    if (window.confirm(`Are you sure you want to delete this question?`)) {
                                        handleDeleteQuestion(qId, isItemActive());
                                    }
                                } else {
                                    handleDeleteQuestion(qId, isItemActive());
                                }
                            }}
                        />
                    </Flexbox>}
            </Section>


            function getItemField(colField, defValue) {
                return getJsonValue(itemData, colField.column, defValue);
            }

            function isItemActive() {
                return isBoolTrue(getItemField(mf.status), true, true);
            }
        }
    }

    function createCreateQsPopup() {
        return <Survey_AddEditQsPage
            showAs={getShowType()}
            updateOnly={isFieldTrue(Fields.addEditQPage_editModeOn)}
            recordId={getField(Fields.currRecordId_addEditQ)}
            surveyId={getField(Fields.surveyId)}
            open={isFieldTrue(Fields.showAddEditQsPopup)}
            onSuccess={() => {
                handleClose();
                fetchPageData(getField(Fields.surveyId), false);
            }}
            onHide={handleClose}
        />

        function handleClose() {
            updateField(Fields.showAddEditQsPopup, false);
            updateField(Fields.currRecordId_addEditQ, null);
            updateField(Fields.addEditQPage_editModeOn, null);
        }

        function getShowType() {
            if (showAs == ShowViewType.DRAWER && isScreenXs) {
                // return ShowViewType.DIALOG;
            }
            switch (showAs) {
                case ShowViewType.PAGE:
                    return ShowViewType.DRAWER;
                case ShowViewType.DRAWER:
                    return ShowViewType.DIALOG;
                case ShowViewType.DIALOG:
                    return ShowViewType.DRAWER;
                default:
                    return ShowViewType.PAGE;
            }
        }
    }


    async function fetchPageData(recordId, checkBefore = true) {
        const fun = 'fetchPageData:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isDataFetched))) {
            log(fun, 'recordId:', recordId);
            updateField(Fields.isDataFetched, true);
            if (checkNullStr(recordId)) {
                updateField(Fields.recordList, []);
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, true);
                updateField(Fields.dataLoadingMsg, "");

                const REQUEST_OPTIONS = {
                    recordId: recordId,
                };
                try {
                    sendRequest({
                        reqUrl: ReqUrls.survey__viewQsPage_fetch_SurveyQs,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const surveyRecord = getJsonValueFromNestedKeys(fetchedData, ['data', 'surveyRecord'], {});
                            const qRecords = getJsonValueFromNestedKeys(fetchedData, ['data', 'qRecords'], []);
                            const success = isJsonValueTrue(fetchedData, 'success');
                            const message = getJsonValue(fetchedData, 'message');

                            updateField(Fields.surveyRecord, surveyRecord);
                            updateField(Fields.surveyId, getJsonValue(surveyRecord, mf_srv.recordId.column));
                            if (success) {
                                // toast(message, CssVariant.success)
                                updateField(Fields.recordList, qRecords);
                            } else {
                                toast(message, CssVariant.danger)
                                updateField(Fields.dataLoadingMsg, message);
                            }
                            updateField(Fields.isDataFound, success);
                            updateField(Fields.isDataLoading, false);
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            toast(Messages.fetchError, CssVariant.danger)
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } catch (error) {
                    toast(Messages.fetchError, CssVariant.danger)
                    logErr(fun, error);
                    updateField(Fields.dataLoadingMsg, Messages.fetchError);
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            } else {
                toast('Record-id not found!', CssVariant.danger);
                updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, false);
            }
        }
    }

    async function handleDeleteQuestion(recordId, isActive) {
        const fun = 'handleDeleteQuestion:';
        if (checkNullStr(recordId)) {
            updateField(Fields.currRecordId_delete, recordId);
            updateField(Fields.recordDeleteBtn_Disable, true);
            updateField(Fields.recordDeleteBtn_AsLoading, true);
            try {
                const REQUEST_OPTIONS = {
                    recordId: recordId,
                    isActive: isActive,
                };
                sendRequest({
                    reqUrl: ReqUrls.survey__viewQsPage_delete_Q,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);
                        const success = isJsonValueTrue(fetchedData, 'success');
                        const message = getJsonValue(fetchedData, 'message');
                        if (success) {
                            toast(message, CssVariant.success);
                            // log(fun, 'getRecordList-old.before:', getArrLen(getRecordList()));

                            const recordList = getRecordList().map((item) => {
                                const isActive = isBoolTrue(getJsonValue(item, mf.status.column), true, true);
                                return {
                                    ...item,
                                    [mf.status.column]: (recordId == getJsonValue(item, mf.recordId.column)) ? !isActive : isActive
                                }
                            });
                            log(fun, 'recordList:', recordList);
                            updateField(Fields.recordList, recordList);

                            if (!checkNullArr(recordList)) {
                                updateField(Fields.isDataFound, false);
                                updateField(Fields.dataLoadingMsg, "No records found!");
                            }
                        } else {
                            toast(message, CssVariant.danger);
                        }
                        updateField(Fields.currRecordId_delete, null);
                        updateField(Fields.recordDeleteBtn_Disable, false);
                        updateField(Fields.recordDeleteBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        logErr(fun, error);
                        toast(`Couldn't ${isActive ? 'Delete' : 'Enable'} the question, please try again!`, CssVariant.danger);
                        updateField(Fields.currRecordId_delete, null);
                        updateField(Fields.recordDeleteBtn_Disable, false);
                        updateField(Fields.recordDeleteBtn_AsLoading, false);
                    }),
                });
            } catch (error) {
                logErr(fun, error);
                toast(`Couldn't ${isActive ? 'Delete' : 'Enable'} the question, please try again!`, CssVariant.danger);
                updateField(Fields.currRecordId_delete, null);
                updateField(Fields.recordDeleteBtn_Disable, false);
                updateField(Fields.recordDeleteBtn_AsLoading, false);
            }
        } else {
            toast('Record-id not found!', CssVariant.danger);
        }
    }

    function getRecordList() {
        return checkNullArr(getField(Fields.recordList)) ? getField(Fields.recordList) : [];
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});
export default Survey_ViewQsPage;
